import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '@web-frontend/shared/components/loading';
import { IconSvgComponent } from './iconSvg.component';

@NgModule({
  declarations: [IconSvgComponent],
  imports: [CommonModule, TranslateModule.forChild(), LoadingModule],
  providers: [],
  exports: [IconSvgComponent],
})
export class IconSvgModule {}
